import { render, staticRenderFns } from "./UserProfileWidget.vue?vue&type=template&id=73f9c6d9&"
import script from "./UserProfileWidget.vue?vue&type=script&lang=js&"
export * from "./UserProfileWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports